import { useEffect } from "react";
import type { ResolvedPageMetadata } from "@/lib/siteMetadata";

function upsertMeta(
  selector: string,
  attributes: Record<string, string>,
  content?: string,
) {
  let element = document.head.querySelector<HTMLMetaElement>(selector);
  if (!element) {
    element = document.createElement("meta");
    for (const [key, value] of Object.entries(attributes)) {
      element.setAttribute(key, value);
    }
    document.head.appendChild(element);
  }
  if (content !== undefined) {
    element.setAttribute("content", content);
  }
}

function upsertLink(rel: string, href: string) {
  let element = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", rel);
    document.head.appendChild(element);
  }
  element.setAttribute("href", href);
}

export function PageHead({ metadata }: { metadata: ResolvedPageMetadata }) {
  useEffect(() => {
    document.title = metadata.title;

    upsertMeta('meta[name="description"]', { name: "description" }, metadata.description);
    upsertLink("canonical", metadata.canonical);

    upsertMeta('meta[property="og:title"]', { property: "og:title" }, metadata.ogTitle);
    upsertMeta(
      'meta[property="og:description"]',
      { property: "og:description" },
      metadata.ogDescription,
    );
    upsertMeta('meta[property="og:url"]', { property: "og:url" }, metadata.canonical);
    upsertMeta('meta[property="og:site_name"]', { property: "og:site_name" }, "doimpo");
    upsertMeta('meta[property="og:type"]', { property: "og:type" }, metadata.ogType);
    upsertMeta('meta[property="og:image"]', { property: "og:image" }, metadata.ogImage);
    upsertMeta(
      'meta[property="og:image:secure_url"]',
      { property: "og:image:secure_url" },
      metadata.ogImage,
    );
    upsertMeta(
      'meta[property="og:image:alt"]',
      { property: "og:image:alt" },
      metadata.ogImageAlt,
    );
    upsertMeta('meta[property="og:image:type"]', { property: "og:image:type" }, "image/jpeg");
    upsertMeta('meta[property="og:image:width"]', { property: "og:image:width" }, "1200");
    upsertMeta('meta[property="og:image:height"]', { property: "og:image:height" }, "630");

    upsertMeta('meta[name="twitter:card"]', { name: "twitter:card" }, metadata.twitterCard);
    upsertMeta('meta[name="twitter:title"]', { name: "twitter:title" }, metadata.ogTitle);
    upsertMeta(
      'meta[name="twitter:description"]',
      { name: "twitter:description" },
      metadata.ogDescription,
    );
    upsertMeta('meta[name="twitter:image"]', { name: "twitter:image" }, metadata.ogImage);
    upsertMeta(
      'meta[name="twitter:image:alt"]',
      { name: "twitter:image:alt" },
      metadata.ogImageAlt,
    );
  }, [metadata]);

  return null;
}
